module.exports = __webpack_public_path__ + "img/briefcase.f3e1ff3c.svg";